import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { ScrollArea } from '../ui/scroll-area';
import { Separator } from '../ui/separator';
import { Filter, Package } from 'lucide-react';
import { getTypeIcon } from './catalogShared';

export function CatalogTypeSidebar({ mainTypes, otherTypes, selectedType, onSelectType, totalCount }) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Filter className="h-4 w-4" />
          Tipologie
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <ScrollArea className="h-[500px]">
          <button
            onClick={() => onSelectType(null)}
            className={`w-full text-left px-4 py-2 flex items-center justify-between transition-colors ${!selectedType ? 'bg-accent text-accent-foreground' : 'hover:bg-muted'}`}
            data-testid="filter-all"
          >
            <span className="flex items-center gap-2">
              <Package className="h-4 w-4" />
              Tutti gli articoli
            </span>
            <Badge variant="secondary">{totalCount}</Badge>
          </button>

          <Separator className="my-2" />

          <div className="px-4 py-1">
            <span className="text-xs font-medium text-muted-foreground">COMPONENTI PRINCIPALI</span>
          </div>
          {mainTypes.map(type => (
            <button
              key={type.code}
              onClick={() => onSelectType(type.code)}
              className={`w-full text-left px-4 py-2 flex items-center justify-between transition-colors ${selectedType === type.code ? 'bg-accent text-accent-foreground' : 'hover:bg-muted'}`}
              data-testid={`filter-${type.code}`}
            >
              <span className="flex items-center gap-2">
                {getTypeIcon(type.code)}
                {type.name}
              </span>
              <Badge variant="secondary">{type.item_count}</Badge>
            </button>
          ))}

          <Separator className="my-2" />

          <div className="px-4 py-1">
            <span className="text-xs font-medium text-muted-foreground">ALTRE TIPOLOGIE</span>
          </div>
          {otherTypes.map(type => (
            <button
              key={type.code}
              onClick={() => onSelectType(type.code)}
              className={`w-full text-left px-4 py-2 flex items-center justify-between text-sm transition-colors ${selectedType === type.code ? 'bg-accent text-accent-foreground' : 'hover:bg-muted'}`}
              data-testid={`filter-${type.code}`}
            >
              <span className="flex items-center gap-2 truncate">
                {getTypeIcon(type.code)}
                <span className="truncate">{type.name}</span>
              </span>
              <Badge variant="secondary" className="ml-2">{type.item_count}</Badge>
            </button>
          ))}
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
